/* React */
import React, { useRef } from "react";

/* Ionic */
import {
  IonItemSliding,
  IonItem,
  IonItemOptions,
} from "@ionic/react";

/* Stylesheet */
import styles from "./ItemSlidingOptions.module.scss";

/* Interfaces */
import { TestDataProps } from "src/shared/interfaces/common/TestData";

interface ItemSlidingOptionsProps {
  item: TestDataProps;
  disabled: boolean;
  option: React.ReactNode;
}

const ItemSlidingOptions: React.FC<
  ItemSlidingOptionsProps
> = ({ item, disabled, option }) => {
  const slidingItemRef =
    useRef<HTMLIonItemSlidingElement | null>(null);

  return (
    <IonItemSliding
      ref={slidingItemRef}
      className={styles.item_sliding_options}
      disabled={disabled}
    >
      <IonItem
        className={`${styles.item_sliding} item_primary`}
        lines="none"
        disabled={disabled}
        button
      >
        <div className={styles.name}>{item?.name}</div>
      </IonItem>
      <IonItemOptions
        side="end"
        onClick={() => {
          if (slidingItemRef.current) {
            slidingItemRef.current.close();
          }
        }}
      >
        {option}
      </IonItemOptions>
    </IonItemSliding>
  );
};

export default ItemSlidingOptions;
